import { HomePage } from '@/components/HomePage';

const Index = () => {
  return <HomePage />;
};

export default Index;
